export default "__VITE_ASSET__3921aa02__"